import qs from 'qs'

import { ReportFilterOperation, ReportValue } from '@driftt/api-types'

import { filterCreator } from 'api/report/query/creators'
import { isNilOrEmpty } from 'utils/ramda'

import QueryBuilder from '../query/QueryBuilder'

const FILTER_BY_OPTIONS = Object.freeze({
  agentsSelected: filterCreator('agentId', ReportFilterOperation.IN),
})

export const filterForType = (
  filterType: string,
  filterValue: ReportValue | ReportValue[]
) => FILTER_BY_OPTIONS[filterType](filterValue)

export default class RealTimeQueryBuilder extends QueryBuilder {
  public queryName?: string

  constructor(defaultFilterProperty = 'firstEndUserMessageAt') {
    super()

    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    const yyyy = today.getFullYear()

    let START_DATE = `${yyyy}-${mm}-${dd}`
    let END_DATE = START_DATE

    const search = window.location.search
    const queryParams = qs.parse(search, { ignoreQueryPrefix: true })
    const isQa = window.DRIFT_REGION === 'QA'
    if (isQa && queryParams.startDate && queryParams.endDate) {
      START_DATE = queryParams.startDate
      END_DATE = queryParams.endDate
    }

    this.filters.push({
      property: defaultFilterProperty,
      operation: ReportFilterOperation.BETWEEN,
      values: [START_DATE, END_DATE],
    })
  }
  public withFilterType(type, value) {
    if (isNilOrEmpty(value)) {
      return this
    }

    this.filters.push(filterForType(type, value))
    return this
  }
  public withFilterGroups(filterGroup: any): this {
    this.filterGroups.push(filterGroup)
    return this
  }

  public withSize(size: number) {
    this.size = size
    return this
  }

  public withQueryName(name: string) {
    this.queryName = name
    return this
  }
}
